import ExternalLinksForgotHandler from './external_links_forgot_handler';

/**
 * Handler for FYP
 */
class ExternalLinksForgotUsernameHandler extends ExternalLinksForgotHandler {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'ExternalLinksForgotUsernameHandler';
    static HandlerName = 'forgot_username';


	/**
	 * Overrides base class executePostMessageActionFallback.
	 * This handler doesn't really care about productPackageOrigin, so we need to call executePostMessageAction either way
	 * Another approach would've been to override the origin test and make it return true
	 * @param postMessageData
	 */
    executePostMessageActionFallback(postMessageData) {
        super.executePostMessageAction(postMessageData);
    }
}

export default ExternalLinksForgotUsernameHandler;